<template>
  <div v-show="editShow">
    <div class="container">
      <el-row :gutter="20">
        <div class="clearfix">
          <div class="crumbs">
            <i class="el-icon-back"></i>
            <el-button type="text" @click="goBack">返回</el-button>
          </div>
          <div class="btn-save">
            <el-button type="primary" @click="saveClick('ruleForm')"
            >保存
            </el-button
            >
          </div>
        </div>
        <div class="form-box">
          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="120px"
              class="eidt-el-form el-form-wrap"
          >
            <div class="line-box">
              <el-form-item label="标题名称:" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>
              <el-form-item label="启用状态:">
                <el-radio-group
                    v-model="ruleForm.disabled"
                >
                  <el-radio :label="0">启用</el-radio>
                  <el-radio :label="1">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="banner" :label="imgTitle">
                <el-input v-model="ruleForm.banner"></el-input>
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item label="投票数量:">
                <el-input-number :max="999999" :min="0" v-model="ruleForm.ticket"></el-input-number>
              </el-form-item>
              <el-form-item label="排序:">
                <el-input-number :max="999999" :min="0" v-model="ruleForm.sort"></el-input-number>
              </el-form-item>
              <el-form-item prop="banner" :label="imgTitle">
                <UploadImg
                    @uploadImg="getUploadImg"
                    :editImg="editImg"
                ></UploadImg>
              </el-form-item>
              <el-form-item label="排序:">
                <el-input-number :max="999999" :min="0" v-model="ruleForm.sort"></el-input-number>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div style="border: 1px solid #ccc;">

<!--          <Toolbar-->
<!--              style="border-bottom: 1px solid #ccc"-->
<!--              :editor="editor"-->
<!--              :defaultConfig="toolbarConfig"-->
<!--              :mode="mode"-->
<!--          />-->
<!--          <Editor-->
<!--              style="height: 500px; overflow-y: hidden;"-->
<!--              v-model="ruleForm.viewPage"-->
<!--              :defaultConfig="editorConfig"-->
<!--              :mode="mode"-->
<!--              @onCreated="onCreated"-->
<!--          />-->
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
import UploadImg from "../public/UploadImg";

export default {
  name: "editvihicel",
  data() {
    return {
      editor: null,
      toolbarConfig: {},
      editorConfig: {placeholder: '请输入内容...'},
      mode: 'default', // or 'simple'
      rules: {
        ticket: [{required: true, message: "票数不能为空", trigger: "blur"},],
        sort: [{required: true, message: "排序不能为空", trigger: "blur"}],
        name: [{required: true, message: "名称不能为空", trigger: "blur"}],
        banner: [{required: true, message: "头部图片不能为空", trigger: "blur"}],
        viewPage: [{required: true, message: "内容不能为空", trigger: "blur"}],
        disabled: [{required: true, message: "启用状态不能为空", trigger: "blur"}],
      },
      projectId: localStorage.getItem("project_Id"),
      ruleForm: {
        sort: 1,
        disabled: 0,
        ticket: 1,
        name: "",
        banner: "",
        voteId: "",
        viewPage: "",
      },
      voteItemId: "",
      editImg: "",
      editImg1: "",
      imgTitle: "头部图片:",
      imgTitle1: "底部图片:",
    };
  },
  created() {
  },
  props: {
    editShow: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
    },
  },
  watch: {
    editData: function () {
      if (this.editData) {
        this.ruleForm = this.editData;
        this.voteItemId = this.editData.voteItemId;
        this.voteId = this.editData.voteId;
        this.editImg = this.editData.banner;
      } else {

      }
    },
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor)
    },
    saveClick(ruleForm) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.voteItemId == "" || this.voteItemId == undefined) {
            this.$axios.post("/VoteItem/", this.ruleForm).then((res) => {
              if (res.data.hasError == false) {
                this.$message.success("保存成功！");
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$axios
                .put("/VoteItem/" + this.voteItemId + "", this.ruleForm)
                .then((res) => {
                  if (res.data.hasError == false) {
                    this.$message.success("编辑成功！");
                    this.goBack();
                  } else {

                    this.$message.error(res.data.message);
                  }
                });
          }
        } else {
          return false;
        }
      });
    }
    ,
    goBack() {
      this.editData = null;
      this.voteItemId = "";
      this.$emit("backFunStu");
      this.$refs.ruleForm.resetFields();
      this.editImg = "";
      this.editImg1 = "";
      this.list.tableData = [];
    }
    ,
    getUploadImg(imgSrc) {
      this.ruleForm.banner = imgSrc;
    }
    ,
  },
}
;
</script>
<style lang="scss" scoped>
.el-form-wrap {
  width: 100% !important;
}

.line-box {
  display: flex;
  flex: 1;
}

.line-box .el-form-item,
.line-box .up-img {
  width: 40% !important;
}

.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
</style>